import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Downgrade: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-9.49 0-18.37-3.73-25.01-10.51l-.21-.22-203.98-216.91c-6.96-7.21-8.95-17.8-5.06-27.05 3.91-9.3 12.96-15.31 23.05-15.31h61.21v-90h300v90h61.21c10.09 0 19.14 6.01 23.05 15.31 3.89 9.25 1.9 19.84-5.06 27.05l-204.19 217.13c-6.64 6.78-15.52 10.51-25.01 10.51zm-3.5-31.43c1.26 1.24 2.73 1.43 3.5 1.43s2.24-.19 3.5-1.43l196.14-208.57h-79.64v-90h-240v90h-79.64z' />
    <path d='m540 150h-300s0-30 0-30h270c16.57 0 30 13.43 30 30z' />
    <path d='m540 240h-300s0-30 0-30h270c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

Downgrade.displayName = 'Downgrade';

export default Downgrade;
